// Thin GA4 wrapper. The base tag (gtag.js + config) is loaded once from
// index.html with send_page_view:false, so pageviews are fired here on
// every client-side route change.

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

// Fires a GA4 page_view. No-op when GA isn't configured (dev / missing
// ID / gtag.js blocked), or when running under headless automation —
// build-time prerender (Playwright) loads every page and would
// otherwise pollute GA with ~77 fake hits per build.
export function trackPageView(path: string, title: string): void {
  const id = import.meta.env.VITE_GA4_MEASUREMENT_ID;
  if (!id || typeof window.gtag !== 'function') return;
  if (typeof navigator !== 'undefined' && navigator.webdriver) return;
  window.gtag('event', 'page_view', {
    page_path: path,
    page_title: title,
    page_location: window.location.href,
  });
}
